import {CounterCart} from '../modules/counter';

export default {
  init() {

    //CART PAGE COUNTER
    const counterProductCart = new CounterCart('.js-add-to-cart', '.js-update-cart-button');
    counterProductCart.init();
  },
  finalize() {

  },
};



// WEBPACK FOOTER //
// ./scripts/routes/woocommerceCart.js